import { combineReducers } from 'redux';

import creatorState, { creatorInitialState } from './creator';
import settingsState, { getSettingsInitialState } from './settings';

export const getCurvesInitialState = () => ({ 
  creatorState: creatorInitialState,
  settingsState: getSettingsInitialState()
})

export default combineReducers({ 
  creatorState,
  settingsState
})